import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: assessments.GradeScheduleSelect.SelectValue.
export default class GradescheduleSelectvalue extends Fragment {
  declare [Type]: 'assessments/gradeschedule-selectvalue';

  @attr('string', { defaultValue: '' })
  declare value: string;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('boolean')
  declare isAddedOption: boolean | undefined;
}
